import React, { memo, useState } from "react";
import { createPortal } from "react-dom";
import { testDriveApi } from "../../services/api";
import { useToast } from "./Toast/ToastProvider";
import "./TestDriveModal.css";

function TestDriveModal({ car, config, currentUser, onClose }) {
  const { showToast } = useToast();
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    preferredDate: "",
    preferredTime: "",
    location: car.location || "",
    name: currentUser?.name || "",
    phone: currentUser?.phone || "",
    notes: "",
    reminderOptIn: true,
  });

  const update = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await testDriveApi.book({
        carId: car._id || car.id,
        ...form,
      });
      showToast({
        type: "success",
        title: config.successTitle,
        message: config.successMessage,
      });
      onClose();
    } catch (err) {
      showToast({
        type: "error",
        title: config.errorTitle,
        message: err.message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return createPortal(
    <div className="td-overlay" role="dialog" aria-modal="true" aria-label={config.title}>
      <div className="td-backdrop" aria-hidden="true" onClick={onClose} />
      <form className="td-modal" onSubmit={submit}>
        <div className="td-header">
          <div>
            <h3>{config.title}</h3>
            <p>{config.subtitle}</p>
          </div>
          <button type="button" className="td-close" onClick={onClose} aria-label={config.closeLabel}>
            x
          </button>
        </div>

        <div className="td-grid">
          <label>
            <span>{config.dateLabel}</span>
            <input
              type="date"
              value={form.preferredDate}
              onChange={(e) => update("preferredDate", e.target.value)}
              required
            />
          </label>
          <label>
            <span>{config.timeLabel}</span>
            <input
              type="time"
              value={form.preferredTime}
              onChange={(e) => update("preferredTime", e.target.value)}
              required
            />
          </label>
          <label className="td-full">
            <span>{config.locationLabel}</span>
            <input
              type="text"
              value={form.location}
              onChange={(e) => update("location", e.target.value)}
            />
          </label>
          <label>
            <span>{config.nameLabel}</span>
            <input
              type="text"
              value={form.name}
              onChange={(e) => update("name", e.target.value)}
            />
          </label>
          <label>
            <span>{config.phoneLabel}</span>
            <input
              type="tel"
              value={form.phone}
              onChange={(e) => update("phone", e.target.value)}
              required
            />
          </label>
          <label className="td-full">
            <span>{config.notesLabel}</span>
            <textarea
              rows="3"
              value={form.notes}
              onChange={(e) => update("notes", e.target.value)}
            />
          </label>
        </div>

        <label className="td-reminder">
          <input
            type="checkbox"
            checked={form.reminderOptIn}
            onChange={(e) => update("reminderOptIn", e.target.checked)}
          />
          <span>{config.reminderLabel}</span>
        </label>

        <div className="td-actions">
          <button type="button" className="td-secondary" onClick={onClose}>
            {config.closeLabel}
          </button>
          <button type="submit" className="td-primary" disabled={submitting}>
            {submitting ? config.submittingLabel : config.submitLabel}
          </button>
        </div>
      </form>
    </div>,
    document.body
  );
}

export default memo(TestDriveModal);
